import React from "react";

import { DoneCheck } from "@ui/Assets/MyIcons";

import { Markdown } from "@containers/Markdown";

import { useTranslate } from "@hooks/useTranslate";

import * as Styled from "./USPs.styled";

interface Props {
  className?: string;
}

export const USPs: React.FC<Props> = ({ className }): React.ReactElement => {
  const translate = useTranslate("batmaid_pwa_static_homepage");

  return (
    <Markdown
      components={{
        ul: props => (
          <Styled.List className={className}>{props.children}</Styled.List>
        ),
        li: props => (
          <Styled.ListElement>
            <DoneCheck width={20} />
            {props.children}
          </Styled.ListElement>
        ),
      }}
    >
      {translate("hero_usps")}
    </Markdown>
  );
};
